module.exports = __webpack_public_path__ + "static/media/secondarylogo.3f3ea58a.svg";